var map = {
	"./casamuyowall.jpg": 566,
	"./food-BOGAVANTE.jpg": 642,
	"./food-PAELLA.jpg": 0,
	"./food5.jpg": 255,
	"./gallery/1.jpg": 296,
	"./gallery/2.jpg": 967,
	"./gallery/3.jpg": 34,
	"./gallery/4.jpg": 521,
	"./gallery/5.jpg": 732,
	"./gallery/6.jpg": 179,
	"./guru/1.png": 51,
	"./guru/2.png": 560,
	"./guru/3.png": 177,
	"./hall.jpg": 565,
	"./history_01.jpeg": 363,
	"./history_02.jpeg": 718,
	"./history_03.jpeg": 405,
	"./logoBlack.jpeg": 921,
	"./logoRed.jpeg": 837,
	"./logoWhite.jpeg": 623,
	"./menu/menu-navidad.jpeg": 556,
	"./open-door.jpeg": 872,
	"./paella-rice.jpeg": 6,
	"./paella.jpeg": 128,
	"./social-media-logos/facebook_64.png": 889,
	"./social-media-logos/instagram_64.png": 387,
	"./social-media-logos/whatsapp_64.png": 99,
	"./social-media-logos/youtube_64.png": 834,
	"./tasteatlas.jpg": 190,
	"./team_01.jpg": 433,
	"./team_02.jpg": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 382;